import type { ImageUrlBuilder } from '@sanity/image-url';
import { useMemo } from 'react';
import { useImageUrlBuilder } from '../sanity/infrastructure/ImageUrlBuilderContext';

export interface Schema {
    '@context': 'https://schema.org';
    '@type': string;
    [key: string]: any;
}

export default function StructuredData<T>({ data, mapper }: { data: T; mapper: (data: T, imageUrlBuilder: ImageUrlBuilder) => Schema }) {
    const imageUrlBuilder = useImageUrlBuilder();
    const json = useMemo(() => {
        try {
            return JSON.stringify(mapper(data, imageUrlBuilder));
        } catch (e) {
            console.error(e);
            return null;
        }
    }, [data]);

    if (!json) return null;

    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} />;
}
